import styled from 'styled-components'
import check from '../../../../assets/addStockModal/pages/check.svg'
import cross from '../../../../assets/addStockModal/pages/cross.svg'

export const Container = styled.div`
    position: absolute;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 1vw;
    z-index: 1;
`


export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 57vw;
    margin-top: 2.8vh;
    margin-left: 1.5vw;
    margin-right: 1vw;
`

export const HeaderText = styled.h2`
    font-family: 'Inter', sans-serif;
    font-size: 1.4vw;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 0;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2vw;
    cursor: pointer;
    width: 2.5vw;
    height: 2.5vw;

    :hover{
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.8vw;
`

export const ProgressBarDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2.8vh;
    margin-left: 0.1vw;
    margin-right: 0.1vw;

    .active{
        background-color: #0090D3;
    }
`

export const ProgressBarCircle = styled.div`
    width: 1vw;
    height: 1vw;
    border-radius: 2vw;
    background-color: #C4C4C4;
`

export const ProgressBarLine = styled.div`
    width: 27vw;
    height: 0.5vh;
    background-color: #C4C4C4;
`

export const InputRowDiv = styled.div`
    display: flex;
    width: 57vw;
    margin-top: 2.5vh;
    margin-left: 1.5vw;
    justify-content: space-between;
`

export const InputDiv = styled.div`
    position: relative;

    .redBorder {
        border: #FF0000 1px solid;
    }

    .empty {
        border: 0;
    }
`

export const InputLabel = styled.label`
    display: block;
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 0.9vw;
`

export const Input = styled.input`
    width: 25.5vw;
    height: 5.3vh;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 2vw;
    margin-top: 0.8vh;
    padding-left: 1vw;
    padding-right: 1vw;

    :focus {
        outline: 0;
    }
`

export const SwitchesDiv = styled.div`
    display: flex;
    margin-top: 3vh;
    align-items: center;
    justify-content: space-between;
    margin-left: 1.5vw;
    margin-right: 4vw;
`

export const SwitchDiv = styled.div`
    display: flex;
    flex-direction: column;
`

export const SwitchLabel = styled.label`
    font-weight: 700;
    font-size: 0.9vw;
    font-family: 'Inter', sans-serif;
`

export const SwitchBox = styled.label`
    display: inline-block;
    position: relative;
    margin-top: 1vh;
    width: 60px;
    height: 34px;
`

export const SwitchInput = styled.input`
    opacity: 0;
    width: 0;
    height: 0;

    :checked + .slider {
        background-color: #2196F3;
        border: 0;
        padding: 2px;
    }

    :focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    :checked + .slider:before {
        background-image: url(${check});
        background-repeat: no-repeat;
        background-position: center;
        background-size: 15px 15px;
        background-color: #fff;
        -webkit-transform: translateX(24px);
        -ms-transform: translateX(24px);
        transform: translateX(24px);
    }
`

export const SwitchSlider = styled.span`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 34px;
    border: #696969 2px solid;

    :before {
        display: block;
        position: relative;
        content: "";
        height: 24px;
        width: 24px;
        left: 5.5px;
        top: 2.8px;
        background-color: #696969;
        border-radius: 50%;
        transition: all 0.4s;
        background-image: url(${cross});
        background-repeat: no-repeat;
        background-position: center;
        background-size: 11px 11px;
    }
`

export const FilesDiv = styled.div`
    display: flex;
    height: 25vh;
    justify-content: space-between;
    margin-left: 1.5vw;
    margin-right: 1.5vw;
`

export const FileBlockDiv = styled.div`
    width: 27vw;
    height: 20vh;

    .down{
        position: relative;
        top: 3.5vh;
    }
`

export const FileHeaderText = styled.p`
    font-weight: 700;
    font-size: 0.9vw;
    font-family: 'Inter', sans-serif;
    margin-bottom: 0;
`

export const FileInputDiv = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 1vh;
    border: dashed #33A6DC 2px;
    border-radius: 0.5vw;
    background-color: #E6F4FB;
`

export const FileInputLabel = styled.label`
    margin-left: 9.7vw;
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 1vw;
    max-width: 7.2vw;
    margin-top: 2vh;
    padding-top: 1.5vh;
    padding-right: 1.5vw;
    padding-bottom: 1.5vh;
    padding-left: 1.5vw;
    background-color: #fff;
    color: #0090D3;
    border: 1px solid #0090D3;
    border-radius: 1.5vw;
    cursor: pointer;
`

export const FilesInfoDiv = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 1vh;
    width: 27vw;
    overflow-y: auto;
    min-height: 6.25vh;
    max-height: 12.5vh;
`

export const FileInfoDiv = styled.div`
    display: flex;
    margin-top: 1vh;
    margin-left: 5.5vw;
    width: 16vw;
    min-height: 5vh;
    border: 1px solid #000;
`

export const FileInfoImg = styled.img`
    width: 1.6vw;
    margin-left: 0.2vw;
`

export const FileMiddleDiv = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 0.6vh;
    margin-left: 0.2vw;
    width: 12vw;
`

export const FileUpperMiddleDiv = styled.div`
    display: flex;
    width: 12vw;
    justify-content: space-between;
`

export const FileName = styled.p`
    margin-top: 0;
    margin-bottom: 0;
    font-size: 0.8vw;
    font-family: 'Inter', sans-serif;
`

export const FilePercentage = styled.p`
    position: relative;
    top: 0.2vh;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 0.8vw;
    font-family: 'Inter', sans-serif;
`

export const FileInfoCancelImg = styled.img`
    margin-left: 0.4vw;
    width: 1.3vw;
`

export const ProgressContainer = styled.div`
    margin-top: 0.8vh;
    width: 12vw;
    height: 4px;
    background-color: #696969;
`

export const ProgressFill = styled.div`
    height: 4px;
    background-color: #6ec1e4;
`

export const CancelImg = styled.img`
    width: 2vw;
`

export const FileInput = styled.input`
    display: none;
`

export const FileFirstText = styled.p`
    font-size: 1.2vw;
    margin-left: 5vw;
    margin-top: 2vh;
    margin-bottom: 0;
    font-family: 'Inter', sans-serif;
`

export const FileSecondText = styled.p`
    color: #696969;
    font-size: 1vw;
    margin-left: 4vw;
    margin-top: 0.5vh;
    margin-bottom: 2vh;
    font-family: 'Inter', sans-serif;
`

export const ButtonsDiv = styled.div`
    display: flex;
    align-items: center;
    margin-left: 41.5vw;

    .disabled {
        background-color: #696969;
        pointer-events: none;
    }
`

export const WarningDiv = styled.div`
    position: absolute;
    display: flex;
    width: 58vw;
    justify-content: end;
    right: 1vw;
    bottom: 7.5vh;
`

export const WarningText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 0.8vw;
    color: #FF0000;
`

export const PreviousButtonDiv = styled.div`
    display: flex;
    align-items: center;
    width: 6.5vw;
    height: 5.8vh;
    background-color: #fff;
    color: #0090D3;
    border: solid #0090D3 1px;
    margin-top: 2.5vh;
    margin-bottom: 2.5vh;
    margin-left: 1vw;
    border-radius: 3vw;
    cursor: pointer;
`

export const PreviousButtonImage = styled.img`
    margin-left: 1vw;   
    width: 0.9vw;
`

export const PreviousButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    font-weight: 700;
    margin-left: 0.6vw;
`

export const NextButtonDiv = styled.div`
    display: flex;
    align-items: center;
    width: 8vw;
    height: 5.8vh;
    background-color: #0090D3;
    color: #fff;
    margin-top: 2.5vh;
    margin-bottom: 2.5vh;
    margin-left: 1vw;
    border-radius: 3vw;
    cursor: pointer;
`

export const NextButtonImage = styled.img`
    margin-left: 1.7vw;   
    width: 0.9vw;
`

export const NextButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    font-weight: 700;
    margin-left: 0.6vw;
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 10px;
`;
